<template>
  <li>
		<div class="row">
			<div class="col-xs-12 col-sm-10">
				<h2 class="truncate">
          <strong>
            <a
              :href="jobHref"
              target="_blank"
              rel="noopener"
            >
              {{ job.number }}
            </a>
          </strong>
        <!-- Only show commodity and locations if we have enough details. -->
        <template v-if="jobHasEnoughDetails">
          - {{ job.commodity_and_location_with_public_quantity }}
        </template>
        </h2>
			</div>
		</div><!-- /.row -->
		<ul class="details" >
			<li v-if="jobHasCoordinator"><span>Coordinator:</span> {{ job.coordinator.profile.full_name }} {{ job.coordinator.mobile }}</li>
			<li v-else><span>&nbsp;</span></li>
		</ul>
		<div class="btn-toolbar">
			<a @click="setActiveJob" class="btn btn-info" data-toggle="modal" data-target=".modal-job-public-details"><i class="fa fa-fw fa-map-marker-alt"></i></a>
		</div>
	</li>
</template>

<script>
import { mapMutations } from 'vuex'
import { isObject } from 'lodash'
import { SET_JOB } from 'vx/mutations'
export default {
  props: ['job'],

  computed: {
    /**
     * Determine if the job has enough details to display the commodity and location
     */
    jobHasEnoughDetails () {
      return isObject(this.job.commodity) ||
        isObject(this.job.location_from) ||
        isObject(this.job.location_to)
    },

    /**
     * Determine if the job has a coordinator so we can display coordinator details
     */
    jobHasCoordinator () {
      return this.job.coordinator
    },

    jobHref () {
      const to = this.job.status === 'pending'
        ? { name: 'jobs.requests.view', params: { id: this.job.id } }
        : { name: 'jobs.show', params: { id: this.job.id } }

      return this.$router.resolve(to).href
    }
  },

  methods: {
    ...mapMutations('job', [SET_JOB]),

    setActiveJob () {
      this[SET_JOB](this.job.decorated)
    }
  }
}
</script>




// WEBPACK FOOTER //
// JobBoardListItem.vue?a3af889e